import React from 'react'
// @ts-ignore
import { Link } from 'react-router-dom'
import {
  CardContainer,
  Chip,
  ChipProps,
  InitialsAvatar,
  LabelValue,
  constants,
  utils as coreUtils,
} from '@adc/ui-core'
import classnames from 'classnames/bind'
import { TransactionCoordinatorProps } from '../types'
import styles from './styles.scss'
import { getInitials } from '../closingOverview/helpers'
import * as gql from '@adc/sdk'
import { ClosingMethod, ClosingStatus } from '@adc/sdk/types'
import ClosingOverview from '../closingOverview'

const cx = classnames.bind(styles)

const TransactionCoordinator: React.FC<TransactionCoordinatorProps> = ({
  transactionCoordinator,
  transactionCoordinatorClosingsData = [],
  selectedStatus,
  redirectUri = '/closings/user',
  slots,
  elmId = 'transaction-coordinator',
}) => {
  let pendingContractCount = 0
  let pendingBuyerContractCount = 0
  let pendingSellerContractCount = 0
  let inClosingCount = 0
  let pendingFundingCount = 0
  let totalInventoryCount = 0

  transactionCoordinator.statuses?.forEach(
    (statusObj: gql.enums.ClosingStatusCount) => {
      switch (statusObj.status) {
        case gql.enums.ClosingStatus.PendingBuyerContract:
          pendingBuyerContractCount += parseInt(statusObj.count)
          break
        case gql.enums.ClosingStatus.PendingSellerContract:
          pendingSellerContractCount += parseInt(statusObj.count)
          break
        case gql.enums.ClosingStatus.PendingContract:
          pendingContractCount += parseInt(statusObj.count)
          break
        case gql.enums.ClosingStatus.PendingFunding:
          pendingFundingCount += parseInt(statusObj.count)
          break
        case gql.enums.ClosingStatus.InClosing:
          inClosingCount += parseInt(statusObj.count)
          break
      }
      totalInventoryCount += parseInt(statusObj.count)
    }
  )
  const hasClosings = transactionCoordinatorClosingsData?.length > 0
  return (
    <div
      className={
        hasClosings ? cx('transaction-coordinator-cards-container') : undefined
      }
    >
      <div className={cx('card-container')}>
        <CardContainer
          borderRadius='extra-small'
          backgroundColor={
            hasClosings
              ? constants.ColorNames.OffWhite
              : constants.ColorNames.White
          }
          dropShadow={hasClosings ? 'large' : 'small'}
          data-elm-id={elmId}
        >
          <div className={cx('header-content')}>
            <div className={cx('group-label-info')}>
              <div className={cx('group-label')}>
                <InitialsAvatar
                  initials={getInitials(transactionCoordinator.name || '')}
                  size='medium'
                  identifier={transactionCoordinator.key}
                />
                <LabelValue
                  label='Transaction Coordinator'
                  value={transactionCoordinator.name || ''}
                />
              </div>
              <Link
                to={`${redirectUri}/${transactionCoordinator.key}/${gql.enums.ClosingStatus.PendingContract}`}
                style={{ textDecoration: 'none' }}
                aria-label='View Pending Contract'
              >
                <Chip
                  className={cx('info-pill-link')}
                  size='small'
                  type='button'
                  selectionStyle='dark'
                  isSelected={
                    selectedStatus === gql.enums.ClosingStatus.PendingContract
                  }
                  content={`Pending Contract: ${coreUtils.formatters.formatMoney(
                    pendingContractCount,
                    { style: 'decimal' }
                  )}`}
                  color={
                    constants.ColorNames.Gray as unknown as ChipProps['color']
                  }
                />
              </Link>
              <Link
                to={`${redirectUri}/${transactionCoordinator.key}/${gql.enums.ClosingStatus.PendingBuyerContract}`}
                style={{ textDecoration: 'none' }}
                aria-label='View Pending Buyer Contract'
              >
                <Chip
                  className={cx('info-pill-link')}
                  size='small'
                  type='button'
                  selectionStyle='dark'
                  isSelected={
                    selectedStatus ===
                    gql.enums.ClosingStatus.PendingBuyerContract
                  }
                  content={`Pending Buyer Contract: ${coreUtils.formatters.formatMoney(
                    pendingBuyerContractCount,
                    { style: 'decimal' }
                  )}`}
                  color={
                    constants.ColorNames.Gray as unknown as ChipProps['color']
                  }
                />
              </Link>
              <Link
                to={`${redirectUri}/${transactionCoordinator.key}/${gql.enums.ClosingStatus.PendingSellerContract}`}
                style={{ textDecoration: 'none' }}
                aria-label='View Pending Seller Contract'
              >
                <Chip
                  className={cx('info-pill-link')}
                  size='small'
                  type='button'
                  selectionStyle='dark'
                  isSelected={
                    selectedStatus ===
                    gql.enums.ClosingStatus.PendingSellerContract
                  }
                  content={`Pending Seller Contract: ${coreUtils.formatters.formatMoney(
                    pendingSellerContractCount,
                    { style: 'decimal' }
                  )}`}
                  color={
                    constants.ColorNames.Gray as unknown as ChipProps['color']
                  }
                />
              </Link>
              <Link
                to={`${redirectUri}/${transactionCoordinator.key}/${gql.enums.ClosingStatus.InClosing}`}
                style={{ textDecoration: 'none' }}
                aria-label='View In Closing'
              >
                <Chip
                  className={cx('info-pill-link')}
                  size='small'
                  type='button'
                  selectionStyle='dark'
                  isSelected={
                    selectedStatus === gql.enums.ClosingStatus.InClosing
                  }
                  content={`In Closing: ${coreUtils.formatters.formatMoney(
                    inClosingCount,
                    { style: 'decimal' }
                  )}`}
                  color={
                    constants.ColorNames
                      .Caution as unknown as ChipProps['color']
                  }
                />
              </Link>
              <Link
                to={`${redirectUri}/${transactionCoordinator.key}/${gql.enums.ClosingStatus.PendingFunding}`}
                style={{ textDecoration: 'none' }}
                aria-label='View Pending Funding'
              >
                <Chip
                  className={cx('info-pill-link')}
                  size='small'
                  type='button'
                  selectionStyle='dark'
                  isSelected={
                    selectedStatus === gql.enums.ClosingStatus.PendingFunding
                  }
                  content={`Pending funding: ${coreUtils.formatters.formatMoney(
                    pendingFundingCount,
                    { style: 'decimal' }
                  )}`}
                  color={
                    constants.ColorNames.Purple as unknown as ChipProps['color']
                  }
                />
              </Link>
              <Link
                to={`${redirectUri}/${transactionCoordinator.key}`}
                style={{ textDecoration: 'none' }}
                aria-label='View Total Inventory'
              >
                <Chip
                  className={cx('info-pill-link')}
                  size='small'
                  type='button'
                  selectionStyle='dark'
                  isSelected={
                    !Object.values(gql.enums.ClosingStatus).includes(
                      selectedStatus as ClosingStatus
                    ) && hasClosings
                  }
                  content={`Total Inventory: ${coreUtils.formatters.formatMoney(
                    totalInventoryCount,
                    { style: 'decimal' }
                  )}`}
                  color={
                    constants.ColorNames.Info as unknown as ChipProps['color']
                  }
                />
              </Link>
            </div>
          </div>
        </CardContainer>
      </div>
      {hasClosings && (
        <div className={cx('closings-container')}>
          {transactionCoordinatorClosingsData.map((closing: ClosingMethod) => {
            return (
              <div className={cx('card-container')}>
                <ClosingOverview
                  slots={slots}
                  closingMethod={closing}
                  dropShadow='small'
                />
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default TransactionCoordinator
